module.exports = __webpack_public_path__ + "media/images/lp_pc-86d4df962f2a83c4ad3ddd97f56165b2.webp";